import {DemoRegistrationFormValues} from './types';

export const DEFAULT_VALUES: DemoRegistrationFormValues = {
  fullCompanyName: '',
  inn: '',
  phone: '',
  email: '',
  website: '',
};

export const PHONE_PATTERN = /^\+7 \([1-9]\d{2}\) \d{3}-\d{2}-\d{2}( #\d{1,4})?$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
